import { TypeUtils } from '@vectord/utils';

import { INSTRUCTOR_CATEGORIES } from '@classCreation/data/instructorCategories';

export default function generateBulkUpdateSbatGroupsInstructors({
  primaryInstructor,
  secondaryInstructor,
  otherInstructors,
}) {
  const sbatGroupInstructors = [];

  if (primaryInstructor?.value) {
    sbatGroupInstructors.push({
      category: INSTRUCTOR_CATEGORIES.primary,
      ...primaryInstructor,
    });
  }

  if (secondaryInstructor?.value) {
    sbatGroupInstructors.push({
      category: INSTRUCTOR_CATEGORIES.secondary,
      ...secondaryInstructor,
    });
  }

  if (TypeUtils.isArray(otherInstructors) && otherInstructors.length > 0) {
    sbatGroupInstructors.push(
      ...otherInstructors?.map((instructor) => ({
        category: INSTRUCTOR_CATEGORIES.other,
        ...instructor,
      }))
    );
  }

  return sbatGroupInstructors;
}
